import { themeVariables } from "Components/theme";
import chroma from "chroma-js";
import { Fill, Stroke, Style } from "ol/style";
import CircleStyle from "ol/style/Circle";
import mapPinBg from "../pointImage/map-pin-bg.svg";
import mapPin from "../pointImage/map-pin.svg";
export const icon = mapPin;
export const iconBg = mapPinBg;
export const buildPointStyle = (defaultColor, color, strokeColor) => new Style({
    image: new CircleStyle({
        radius: 6,
        fill: new Fill({
            color: color || defaultColor
        }),
        stroke: new Stroke({
            color: strokeColor || "#ffffff",
            width: 2,
            lineCap: "round",
            lineJoin: "round"
        })
    }),
    zIndex: Infinity
});
export const buildLineStyle = (defaultColor, color, lineWidth, alpha = 0.95) => new Style({
    stroke: new Stroke({
        color: chroma(color || defaultColor)
            .alpha(alpha)
            .css(),
        width: lineWidth,
        lineCap: "round",
        lineJoin: "round"
    })
});
export const buildAreaStyle = (defaultColor, color, alpha = 0.2) => new Style({
    fill: new Fill({
        color: chroma(color || defaultColor)
            .alpha(alpha)
            .css()
    })
});
export const geometryStyles = (defaultColor, color, active = true, linesMaxAlpha = 1) => [
    buildAreaStyle(defaultColor, color, active ? 0.15 : 0.25),
    buildLineStyle(defaultColor, color, 4, Math.min(active ? 0.7 : 0.5, linesMaxAlpha)),
    buildLineStyle(defaultColor, color, 1, Math.min(1, linesMaxAlpha)),
    buildPointStyle(defaultColor, color)
];
export const geometryStylesPrimary = geometryStyles(themeVariables["brand-primary-500"]);
